export default __webpack_public_path__ + "static/B0319-49454aa585b054c6c157cabec44b370a.png";